import styled from 'styled-components';
import { colors } from '@/globalStyles';

export const MatrixFormatWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-row-gap: 20px;
`;

export const InputContainerWhite = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  height: 49px;
  max-height: 49px;
  font-weight: 400;
  border-radius: 4px;
  background-color: #ffffff;
  overflow: hidden;
`;

export const MatrixRemoveCell = styled.div`
  width: 100%;
  height: 45px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
`;

export const MatrixCellRect = styled.div`
  display: flex;
  justify-content: space-evenly;
  margin-left: 15px;
  background-color: none;
  border: 1px solid #000000;
  border-radius: 4px;
  height: 100%;
  width: 100%;
`;

export const HorizontalLine = styled.div`
  display: ${props => (props.isHidden ? 'none' : 'default')};
  height: 1px;
  width: 100%;
  background-color: #e1e5e9;
`;

export const VerticalLine = styled.div`
  display: block;
  height: 100%;
  width: 1px;
  background-color: #000000;
`;

export const LabelBold = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  font-size: 16px;
  line-height: 18px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-family: Lato;
  font-weight: 600;
`;

export const Icon = styled.img`
  width: 30px;
  height: 30px;
  cursor: pointer;
`;

export const Icon20 = styled.img`
  width: 20px;
  height: 20px;
  cursor: pointer;
`;

export const AddRowStyled = styled.div`
  display: grid;
  grid-template-columns: max-content 1fr;
  align-items: center;
  gap: 15px;
  color: ${colors.primary};
  cursor: pointer;
`;